<h2 mat-dialog-title>
  Recepción de Material
</h2>

<div class="accordion-container">
  <mat-accordion>
    @for (data of uiData; track data) {
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title class="custom-title">
            <strong>{{ data.code }}</strong>
          </mat-panel-title>
          <mat-panel-description class="custom-description">
            <span class="desc-text">{{ data.description }}</span>
            @if (data.accepted) {
              <button class="btn-aceptar" disabled
                mat-raised-button
                color="warn"
                (click)="acceptProduct($event, data.id)">
                Aceptado
              </button>
            }
            @if (!data.accepted) {
              <button class="btn-aceptar"
                mat-raised-button
                color="primary"
                (click)="acceptProduct($event, data.id)">
                Aceptar
              </button>
            }
          </mat-panel-description>
        </mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
          @if (data.items.length > 0) {
            <div class="list-container">
              <mat-list>
                @for (item of data.items; track item) {
                  <mat-list-item>
                    <div mat-line>
                      <strong>{{ item.tagRfid }}</strong>
                    </div>
                    <div mat-line class="item-details">
                      Lote: {{ item.batch }} &nbsp;|&nbsp; Caducidad: {{ item.expiration }}
                    </div>
                  </mat-list-item>
                }
              </mat-list>
            </div>
          }
          @if (data.items.length === 0) {
            <p class="empty-msg">
              No hay inventario para este código.
            </p>
          }
        </ng-template>
      </mat-expansion-panel>
    }
  </mat-accordion>
</div>

<mat-dialog-actions align="end">
  <button mat-raised-button mat-dialog-close>
    <mat-icon>close</mat-icon>
    Cerrar
  </button>
</mat-dialog-actions>